// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__2CzvT","avatar":"Panel_avatar__2OaKc","brand":"Panel_brand__1E-k8","share":"Panel_share__10ADF","counter":"Panel_counter__2L1ew"};